import { render, staticRenderFns } from "./BlackjackSeatElement.vue?vue&type=template&id=13c273a2&scoped=true"
import script from "./BlackjackSeatElement.vue?vue&type=script&lang=js"
export * from "./BlackjackSeatElement.vue?vue&type=script&lang=js"
import style0 from "./BlackjackSeatElement.vue?vue&type=style&index=0&id=13c273a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c273a2",
  null
  
)

export default component.exports